/**
 * WordPress dependencies
 */
import { render } from '@wordpress/element';

/**
 * External dependencies.
 */
import TemplateKitBrowser from './browser';
import NoBlockTheme from './no-block-theme';
const App = () => {
	return <>
		{ !! window._gutenify_kit.is_block_theme && <TemplateKitBrowser /> }
		{ ! window._gutenify_kit.is_block_theme && <NoBlockTheme /> }
	</>;
};
render(
	<App />,
	document.getElementById( 'gutenify-template-kit-app' )
);
